export const normalizeURL = (url?: string) => {
  if (!url) return ""
  const uri = url.replace("www.", "").replace(/https?\:\/\//gi, "")

  const protocol = "https://www."

  return `${protocol}${uri}`
}
